export default "__VITE_ASSET__DHp4vsaW__"